import { Breadcrumb, TitleScreen } from "components/Core"
import CollapseWithDetail from "components/Core/Collapse/WithDetail"
import DetailHistoryStatus from "components/Custom/DetailHistoryStatus"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { format_datetime_by_local_client } from "helpers/datetime_helper"
import useSearchMiddlewareOSRM from "hooks/useSearchMiddlewareOSRM"

const DetailScreen = () => {
  const [serie, set_data] = useState<any>()
  const { series_id } = useParams<{ series_id: string }>()
  
  const { data: data_series, search_osrm_action } = useSearchMiddlewareOSRM({
    entity: "series",
  })

  useEffect(() => {
    if (series_id) {
      search_osrm_action({ from: 0, size: 1, filters: { id: series_id } })
    }
    // eslint-disable-next-line
  }, [series_id])

  useEffect(() => {
    if (data_series?.records?.length) {
      set_data(data_series.records[0])
    }
  }, [data_series])

  const creationDate = serie?._omnixMetadata?.createdAt || serie?.creationDate
  const statusLabel = serie?.estadoOmnix || serie?._omnixStateMachine?.currentState?.state?.name || "Desconocido"
  
  return (
    <div className="w-full h-full flex flex-col items-start justify-start">
      <Breadcrumb
        data={[
          { name: "Listado de series", href: "/series" },
          { name: "Detalles", href: `/series/${series_id}` },
        ]}
      />
      <div className="w-full flex flex-col justify-center items-center py-4 px-6">
        <TitleScreen title="Detalle de serie" string_id={serie?.serieSap || series_id} />
      </div>
      
      {/* State timeline (if available) */}
      <div className="w-full h-auto py-4 px-6">
        <DetailHistoryStatus statusses={serie?._omnixStateMachine?.states || []} />
      </div>
      
      <div className="w-full flex flex-col lg:flex-row gap-6 py-4 px-6">
        <div className="w-full lg:w-1/2 flex flex-col gap-4">
          <div className="w-full flex flex-col gap-2">
            <h4 className="font-semibold text-[#4C4C4C]">Información Primaria</h4>
            <div className="grid grid-cols-2 grid-rows-3 bg-white rounded-xl border divide-x divide-y">
              <p className="text-sm text-[#4C4C4C] px-4 py-3">Serie SAP</p>
              <p className="text-sm font-bold text-gray-800 px-4 py-3">{serie?.serieSap || "N/A"}</p>
              
              <p className="text-sm text-[#4C4C4C] px-4 py-3">SKU Comercial</p>
              <p className="text-sm text-indigo-600 px-4 py-3">{serie?.sku || "N/A"}</p>
              
              <p className="text-sm text-[#4C4C4C] px-4 py-3">Ruteo/Almacén</p>
              <p className="text-sm text-[#4C4C4C] px-4 py-3">{serie?.almacen || "Sin Ruta"}</p>
            </div>
          </div>
          
          <CollapseWithDetail
            title="Metadata Transaccional"
            details={{
              Centro: serie?.centroSAP || "No Asignado",
              Cód_Documento: serie?.codigoDocumento || "N/A",
              Material: serie?.material || "N/A",
            }}
          />
        </div>
        
        <div className="w-full lg:w-1/2 flex flex-col gap-4">
          <div className="w-full flex flex-col gap-2">
            <h4 className="font-semibold text-[#4C4C4C]">Gestión Omnix</h4>
            <div className="grid grid-cols-2 grid-rows-4 bg-white rounded-xl border divide-x divide-y">
              <p className="text-sm text-[#4C4C4C] px-4 py-3">Fecha Integración</p>
              <p className="text-sm text-[#4C4C4C] px-4 py-3 whitespace-nowrap">
                {creationDate ? format_datetime_by_local_client(new Date(parseInt(creationDate) || creationDate), "dd MMM, HH:mm") : "--"}
              </p>
              
              <p className="text-sm text-[#4C4C4C] px-4 py-3">Estado Final</p>
              <p className="text-sm font-semibold text-emerald-600 px-4 py-3 uppercase">{statusLabel}</p>
              
              <p className="text-sm text-[#4C4C4C] px-4 py-3">Entidad OSRM (UUID)</p>
              <p className="text-xs text-gray-400 px-4 py-3 break-words">{series_id}</p>
              
              <p className="text-sm text-[#4C4C4C] px-4 py-3">Último Audit</p>
              <p className="text-sm text-[#4C4C4C] px-4 py-3">
                {serie?._omnixMetadata?.updatedAt ? format_datetime_by_local_client(new Date(parseInt(serie._omnixMetadata.updatedAt)), "dd MMM yyyy, HH:mm") : "--"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DetailScreen
